module.exports = __webpack_public_path__ + "static/media/elegirSucursal__calendario.76b0bdf5.svg";